import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Layout } from './components/Layout/Layout';
import { LoginPage } from './pages/LoginPage';
import { TimesheetPage } from './pages/TimesheetPage';
import { AdminPage } from './pages/AdminPage';
import { ReportsPage } from './pages/ReportsPage';
import { ChartsPage } from './pages/ChartsPage';

function RequireAuth({ children }: { children: React.ReactNode }) {
	const { user, loading } = useAuth();
	if (loading) return <div style={{ padding: 24, color: '#737373' }}>Chargement…</div>;
	if (!user) return <Navigate to="/login" replace />;
	return <>{children}</>;
}

function RequireManager({ children }: { children: React.ReactNode }) {
	const { user } = useAuth();
	if (!user?.isManager) return <Navigate to="/" replace />;
	return <>{children}</>;
}

function RequireManagerOrResponsible({ children }: { children: React.ReactNode }) {
	const { user } = useAuth();
	if (!user?.isManager && !user?.isResponsible) return <Navigate to="/" replace />;
	return <>{children}</>;
}

export function App() {
	// Swallow Ctrl/Cmd+S app-wide so the browser "Save page" dialog never opens.
	useEffect(() => {
		function onKey(e: KeyboardEvent) {
			if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'S')) {
				e.preventDefault();
			}
		}
		document.addEventListener('keydown', onKey);
		return () => document.removeEventListener('keydown', onKey);
	}, []);

	return (
		<AuthProvider>
			<Routes>
				<Route path="/login" element={<LoginPage />} />

				<Route
					element={
						<RequireAuth>
							<Layout />
						</RequireAuth>
					}
				>
					<Route index element={<TimesheetPage />} />
					<Route
						path="reports"
						element={
							<RequireManagerOrResponsible>
								<ReportsPage />
							</RequireManagerOrResponsible>
						}
					/>
					<Route
						path="charts"
						element={
							<RequireManagerOrResponsible>
								<ChartsPage />
							</RequireManagerOrResponsible>
						}
					/>
					<Route
						path="admin"
						element={
							<RequireManager>
								<AdminPage />
							</RequireManager>
						}
					/>
				</Route>

				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</AuthProvider>
	);
}
